import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Grid, KeyValue } from 'web-library';
import { candidateService } from '../../../api';

const NonNationalExamTypeUuidDisplay = ({
  enableApi = true,
  nonExamType,
}: {
  enableApi?: boolean;
  nonExamType?: string;
}) => {
  const { t } = useTranslation();
  const [examTypeDisplay, setExamTypeDisplay] = useState<string>('-');
  const [candidateNameDisplay, setCandidateNameDisplay] = useState<string | null>(null);

  // @ts-ignore
  const { uuid: examRegistrationUuid } = useParams();

  const { data } = candidateService.exam.candidate.useGetExamRegistration(examRegistrationUuid, {
    enabled: enableApi,
  });

  useEffect(() => {
    if (data && data.name && examRegistrationUuid) {
      setCandidateNameDisplay(data.name);
    }
  }, [data, examRegistrationUuid, examTypeDisplay, candidateNameDisplay]);

  useEffect(() => {
    if (nonExamType) {
      setExamTypeDisplay(nonExamType);
    }
  }, [nonExamType, examTypeDisplay]);

  return (
    <Grid container direction="row" alignItems="flex-start">
      <KeyValue
        keyText={t('exam->>RegisterExamInstructions.Exam Level')}
        valueText={examTypeDisplay}
      />
      {candidateNameDisplay && (
        <Grid xs={12} sm={6}>
          <KeyValue
            keyText={t('exam->>RegisterExamInstructions.CandidateName')}
            valueText={candidateNameDisplay}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default NonNationalExamTypeUuidDisplay;
